// tslint:disable:max-line-length

import React from 'react';

export const ActionBlocked = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <g transform="translate(-61.000000, -409.000000)">
        <path d="M69,409 C73.418278,409 77,412.581722 77,417 C77,421.418278 73.418278,425 69,425 C64.581722,425 61,421.418278 61,417 C61,412.581722 64.581722,409 69,409 Z M73.8823828,414.465275 L66.1312852,421.693519 C66.9665007,422.2051 67.9488116,422.5 69,422.5 C72.0375661,422.5 74.5,420.037566 74.5,417 C74.5,416.085856 74.2769806,415.2238 73.8823828,414.465275 Z M69,411.5 C65.9624339,411.5 63.5,413.962434 63.5,417 C63.5,417.895926 63.7142188,418.741819 64.0942301,419.489252 L71.8254727,412.280267 C70.9996758,411.784839 70.0331018,411.5 69,411.5 Z" />
      </g>
    </svg>
  );
};
